<style lang="scss">
.foot-switch {
  &__input,
  &__textarea {
    background-color: #f3f3f3;
    border: 3px solid #1976d2;
    border-radius: 10px;
    outline: none;
  }

  &__input {
    width: 100px;
    height: 90px;
  }

  &__textarea {
    width: 400px;
    height: 160px;
    resize: none;
  }
}
</style>

<template>
  <div class="pa-5 foot-switch">
    <div class="text-xs-center">
      <v-slide-x-transition hide-on-leave>
        <div v-if="isSingleMode" class="mb-5 display-4 font-weight-regular">
          <p class="mb-0">
            <span class="d-inline-block red--text text--lighten-2 --attention">
              單次
            </span>
            踩踏板
          </p>
          <input
            v-model="single"
            ref="single"
            type="text"
            maxlength="1"
            readonly
            class="mt-5 display-3 text-xs-center text-uppercase foot-switch__input"
          />
        </div>
      </v-slide-x-transition>
      <v-slide-x-transition hide-on-leave>
        <div v-if="isMultipleMode" class="mb-5 display-4 font-weight-regular">
          <p class="mb-0">
            <span class="d-inline-block red--text text--lighten-2 --attention">
              持續
            </span>
            踩踏板
          </p>
          <textarea
            v-model="multiple"
            ref="multiple"
            readonly
            class="mt-5 display-3 text-xs-center text-uppercase foot-switch__textarea"
          />
        </div>
      </v-slide-x-transition>
    </div>

    <faq-switch-drawer title="踏板" :items="faqs" />
  </div>
</template>

<script>
import { throttle } from 'lodash'

import FaqSwitchDrawer from './faq-drawer'

const KEY_Z = 90

export default {
  name: 'FootSwitch',
  components: {
    FaqSwitchDrawer,
  },
  data() {
    return {
      single: '',
      isSingleMode: true,
      isSingleValid: false,
      multiple: '',
      isMultipleMode: false,
      isMultipleValid: false,
      faqs: [{ id: 1, text: '如果踩踏板沒有" Z "，請重新插拔或更換新踏板。' }],
    }
  },
  computed: {
    isValid() {
      return this.isSingleValid && this.isMultipleValid
    },
  },
  watch: {
    single(v) {
      if (v === 'z') {
        this.isSingleValid = true
        this.notify()

        setTimeout(() => {
          this.isSingleMode = false
          this.isMultipleMode = true
        }, 2000)
      }
    },
    multiple(v) {
      if (!this.isMultipleValid && v.length >= 5 && v === 'zzzzz') {
        this.isMultipleValid = true
        addEventListener('keydown', this.throttleKeydown)
        this.notify()
      }
    },
    isValid(nv, ov) {
      if (nv && !ov) {
        setTimeout(() => {
          this.$emit('valid', { step: 1, valid: true })
        }, 2500)
      }
    },
  },
  created() {
    this.throttleKeydown = throttle(this.keydown, 500, { leading: true })
    addEventListener('keydown', this.throttleKeydown)
  },
  beforeDestroy() {
    addEventListener('keydown', this.throttleKeydown)
  },
  methods: {
    keydown(evt) {
      const { key, keyCode } = evt

      if (this.isSingleMode) {
        this.single = key
      } else if (
        keyCode === KEY_Z &&
        this.isMultipleMode &&
        !this.isMultipleValid
      ) {
        this.multiple = this.multiple.concat(key)
      }

      if (keyCode !== KEY_Z) {
        this.$emit('valid', { step: 1, valid: false })
      }
    },
    notify() {
      this.$emit('notify')
    },
  },
}
</script>
